import { APP_CONFIG } from '../../js/config.js';
import { appState } from '../../js/state.js';

import { isNodeEnvironment } from '../../js/utils-fetch-data-json.js';
import {
  saveToLocalStorage,
  loadFromLocalStorage,
  saveToLocalStorageWithLimitAndExpiry,
} from '../../js/utils-local-storage.js';

export async function fetchPageSEOTagsAsync(pageTranslateKey) {
  try {
    if (isNodeEnvironment()) {
      console.log('🌐 Static build: fetching page SEO from live API');
      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/SEODataService/GetPageTitleAndSEOTagForStaticPageByTranslateKeyAsync?translateKey=${pageTranslateKey}&languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);
      if (!response.ok) throw new Error(`Failed to fetch fetchPageSEOTagsAsync  from server`);
      const allSubcategories = await response.json();
      return allSubcategories;
    } else {
      const storageKey = `seo_${pageTranslateKey}_${appState.SiteLanguageCookie}`;
      const expiryKey = `${storageKey}_expiry`;
      const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds
      // Check cache first
      const cached = loadFromLocalStorage(storageKey);
      const expiryTime = loadFromLocalStorage(expiryKey);
      if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
        console.log(`✅ Loaded All  fetchPageSEOTagsAsync from cache`);
        return cached;
      }

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/SEODataService/GetPageTitleAndSEOTagForStaticPageByTranslateKeyAsync?translateKey=${pageTranslateKey}&languageCode=${appState.SiteLanguageCookie}`;

      const response = await fetch(apiEndPoint);
      if (!response.ok) throw new Error(`Failed to fetch fetchPageSEOTagsAsync  from server`);
      const allSubcategories = await response.json();
      // Save to localStorage
      saveToLocalStorage(storageKey, allSubcategories);
      saveToLocalStorage(expiryKey, Date.now() + expiryDuration);
      console.log(`🌐 Fetched fetchPageSEOTagsAsync from the server`);
      return allSubcategories;
    }
  } catch (error) {
    console.error('❌ Error fetchPageSEOTagsAsync:', error);
    return [];
  }
}

export async function fetchGetBlogCategorySEOTagsByCategoryID(selectedArticleCategoryID) {
  try {
    if (isNodeEnvironment()) {
      console.log('🌐 Static build: fetching page SEO from live API');
      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/SEODataService/GetBlogCategorySEOCanonicalByBlogCategoryIDAsync?blogCategoryID=${selectedArticleCategoryID}&languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);
      if (!response.ok)
        throw new Error(`Failed to fetch fetchGetBlogCategorySEOTagsByCategoryID  from server`);
      const allSubcategories = await response.json();
      return allSubcategories;
    } else {
      const storageKey = `seo_blog_cat_${selectedArticleCategoryID}_${appState.SiteLanguageCookie}`;
      const expiryKey = `${storageKey}_expiry`;
      const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds
      // Check cache first
      const cached = loadFromLocalStorage(storageKey);
      const expiryTime = loadFromLocalStorage(expiryKey);
      if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
        console.log(`✅ Loaded All  fetchGetBlogCategorySEOTagsByCategoryID from cache`);
        return cached;
      }

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/SEODataService/GetBlogCategorySEOCanonicalByBlogCategoryIDAsync?blogCategoryID=${selectedArticleCategoryID}&languageCode=${appState.SiteLanguageCookie}`;

      const response = await fetch(apiEndPoint);
      if (!response.ok)
        throw new Error(`Failed to fetch fetchGetBlogCategorySEOTagsByCategoryID  from server`);
      const allSubcategories = await response.json();
      // Save to localStorage
      saveToLocalStorage(storageKey, allSubcategories);
      saveToLocalStorage(expiryKey, Date.now() + expiryDuration);
      console.log(`🌐 Fetched fetchGetBlogCategorySEOTagsByCategoryID from the server`);
      return allSubcategories;
    }
  } catch (error) {
    console.error('❌ Error fetchGetBlogCategorySEOTagsByCategoryID:', error);
    return [];
  }
}

export async function fetchGetBlogArticleSEOTagsByArticleIDAndDefaultArticleCategoryID(
  selectedArticleID,
  selectedDefaultArticleCategoryID
) {
  try {
    if (isNodeEnvironment()) {
      console.log('🌐 Static build: fetching page SEO from live API');
      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/SEODataService/GetBlogArticleSEOCanonicalByArticleIDAndDefaultArticleCategoryIDAsync?articleID=${selectedArticleID}&defaultArticleCategoryID=${selectedDefaultArticleCategoryID}&languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);
      if (!response.ok)
        throw new Error(`Failed to fetch fetchGetBlogCategorySEOTagsByCategoryID  from server`);
      const allSubcategories = await response.json();
      return allSubcategories;
    } else {
      const storageKey = `seo_blog_art_${selectedArticleID}_cat_${selectedDefaultArticleCategoryID}_${appState.SiteLanguageCookie}`;
      const expiryKey = `${storageKey}_expiry`;
      const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds
      // Check cache first
      const cached = loadFromLocalStorage(storageKey);
      const expiryTime = loadFromLocalStorage(expiryKey);
      if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
        console.log(`✅ Loaded All  fetchGetBlogCategorySEOTagsByCategoryID from cache`);
        return cached;
      }

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/SEODataService/GetBlogArticleSEOCanonicalByArticleIDAndDefaultArticleCategoryIDAsync?articleID=${selectedArticleID}&defaultArticleCategoryID=${selectedDefaultArticleCategoryID}&languageCode=${appState.SiteLanguageCookie}`;

      const response = await fetch(apiEndPoint);
      if (!response.ok)
        throw new Error(`Failed to fetch fetchGetBlogCategorySEOTagsByCategoryID  from server`);
      const allSubcategories = await response.json();
      // Save to localStorage
      saveToLocalStorage(storageKey, allSubcategories);
      saveToLocalStorage(expiryKey, Date.now() + expiryDuration);
      console.log(`🌐 Fetched fetchGetBlogCategorySEOTagsByCategoryID from the server`);
      return allSubcategories;
    }
  } catch (error) {
    console.error('❌ Error fetchGetBlogCategorySEOTagsByCategoryID:', error);
    return [];
  }
}

export async function fetchGetCatalogCategorySEOTagsByCategoryID(selectedCategoryID) {
  try {
    if (isNodeEnvironment()) {
      console.log('🌐 Static build: fetching page SEO from live API');
      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/SEODataService/GetDepartmentSEOCanonicalByDepartmentIDAsync?departmentID=${selectedCategoryID}&languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);
      if (!response.ok)
        throw new Error(`Failed to fetch fetchGetCatalogCategorySEOTagsByCategoryID  from server`);
      const allSubcategories = await response.json();
      return allSubcategories;
    } else {
      const storageKey = `seo_cat_${selectedCategoryID}_${appState.SiteLanguageCookie}`;
      const expiryKey = `${storageKey}_expiry`;
      const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds
      // Check cache first
      const cached = loadFromLocalStorage(storageKey);
      const expiryTime = loadFromLocalStorage(expiryKey);
      if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
        console.log(`✅ Loaded All  fetchGetCatalogCategorySEOTagsByCategoryID from cache`);
        return cached;
      }

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/SEODataService/GetDepartmentSEOCanonicalByDepartmentIDAsync?departmentID=${selectedCategoryID}&languageCode=${appState.SiteLanguageCookie}`;

      const response = await fetch(apiEndPoint);
      if (!response.ok)
        throw new Error(`Failed to fetch fetchGetBlogCategorySEOTagsByCategoryID  from server`);
      const allSubcategories = await response.json();
      // Save to localStorage
      saveToLocalStorage(storageKey, allSubcategories);
      saveToLocalStorage(expiryKey, Date.now() + expiryDuration);
      console.log(`🌐 Fetched fetchGetCatalogCategorySEOTagsByCategoryID from the server`);
      return allSubcategories;
    }
  } catch (error) {
    console.error('❌ Error fetchGetCatalogCategorySEOTagsByCategoryID:', error);
    return [];
  }
}

export async function fetchGetCatalogSubcategorySEOTagsByCategoryID(selectedSubcategoryID) {
  try {
    if (isNodeEnvironment()) {
      console.log('🌐 Static build: fetching page SEO from live API');
      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/SEODataService/GetCategorySEOCanonicalByCategoryIDAsync?categoryID=${selectedSubcategoryID}&languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);
      if (!response.ok)
        throw new Error(
          `Failed to fetch fetchGetCatalogSubcategorySEOTagsByCategoryID  from server`
        );
      const allSubcategories = await response.json();
      return allSubcategories;
    } else {
      const storageKey = `seo_subcat_${selectedSubcategoryID}_${appState.SiteLanguageCookie}`;
      const expiryKey = `${storageKey}_expiry`;
      const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds
      // Check cache first
      const cached = loadFromLocalStorage(storageKey);
      const expiryTime = loadFromLocalStorage(expiryKey);
      if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
        console.log(`✅ Loaded All  fetchGetCatalogSubcategorySEOTagsByCategoryID from cache`);
        return cached;
      }

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/SEODataService/GetCategorySEOCanonicalByCategoryIDAsync?categoryID=${selectedSubcategoryID}&languageCode=${appState.SiteLanguageCookie}`;

      const response = await fetch(apiEndPoint);
      if (!response.ok)
        throw new Error(`Failed to fetch fetchGetBlogCategorySEOTagsByCategoryID  from server`);
      const allSubcategories = await response.json();
      // Save to localStorage
      saveToLocalStorage(storageKey, allSubcategories);
      saveToLocalStorage(expiryKey, Date.now() + expiryDuration);
      console.log(`🌐 Fetched fetchGetCatalogSubcategorySEOTagsByCategoryID from the server`);
      return allSubcategories;
    }
  } catch (error) {
    console.error('❌ Error fetchGetCatalogSubcategorySEOTagsByCategoryID:', error);
    return [];
  }
}

export async function fetchGetCatalogProductSEOTagsByProductID(selectedProductID) {
  try {
    if (isNodeEnvironment()) {
      console.log('🌐 Static build: fetching page SEO from live API');
      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/SEODataService/GetProductSEOCanonicalByProductIDAsync?productID=${selectedProductID}&languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);
      if (!response.ok)
        throw new Error(`Failed to fetch fetchGetCatalogProductSEOTagsByProductID  from server`);
      const allSubcategories = await response.json();
      return allSubcategories;
    } else {
      const storageKey = `seo_prod_${selectedProductID}_${appState.SiteLanguageCookie}`;
      const expiryKey = `${storageKey}_expiry`;
      const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds
      // Check cache first
      const cached = loadFromLocalStorage(storageKey);
      const expiryTime = loadFromLocalStorage(expiryKey);
      if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
        console.log(`✅ Loaded All  fetchGetCatalogProductSEOTagsByProductID from cache`);
        return cached;
      }

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/SEODataService/GetProductSEOCanonicalByProductIDAsync?productID=${selectedProductID}&languageCode=${appState.SiteLanguageCookie}`;

      const response = await fetch(apiEndPoint);
      if (!response.ok)
        throw new Error(`Failed to fetch fetchGetBlogCategorySEOTagsByCategoryID  from server`);
      const allSubcategories = await response.json();
      // Save to localStorage
      saveToLocalStorage(storageKey, allSubcategories);
      saveToLocalStorage(expiryKey, Date.now() + expiryDuration);
      console.log(`🌐 Fetched fetchGetCatalogProductSEOTagsByProductID from the server`);
      return allSubcategories;
    }
  } catch (error) {
    console.error('❌ Error fetchGetCatalogProductSEOTagsByProductID:', error);
    return [];
  }
}
